import React from "react";
import { useTranslation } from "react-i18next";
import { useLegalDocument } from "../../hooks/useLegalDocument";
import LegalDocumentBody from "./LegalDocumentBody";

const SECTION_KEYS: { title: string; body: string[] }[] = [
  {
    title: "businessTerms.acceptance.title",
    body: ["businessTerms.acceptance.p1", "businessTerms.acceptance.p2"],
  },
  {
    title: "businessTerms.eligibility.title",
    body: ["businessTerms.eligibility.p1", "businessTerms.eligibility.p2"],
  },
  {
    title: "businessTerms.fees.title",
    body: ["businessTerms.fees.p1", "businessTerms.fees.p2"],
  },
  {
    title: "businessTerms.payment.title",
    body: ["businessTerms.payment.p1", "businessTerms.payment.p2"],
  },
  {
    title: "businessTerms.coupon.title",
    body: [
      "businessTerms.coupon.p1",
      "businessTerms.coupon.p2",
      "businessTerms.coupon.p3",
      "businessTerms.coupon.p4",
      "businessTerms.coupon.p5",
      "businessTerms.coupon.p6",
    ],
  },
  {
    title: "businessTerms.cancellation.title",
    body: [
      "businessTerms.cancellation.p1",
      "businessTerms.cancellation.p2",
      "businessTerms.cancellation.p3",
    ],
  },
  {
    title: "businessTerms.latePayment.title",
    body: ["businessTerms.latePayment.p1"],
  },
  {
    title: "businessTerms.obligations.title",
    body: ["businessTerms.obligations.p1", "businessTerms.obligations.p2"],
  },
  {
    title: "businessTerms.listings.title",
    body: ["businessTerms.listings.p1"],
  },
  {
    title: "businessTerms.platformRole.title",
    body: ["businessTerms.platformRole.p1"],
  },
  {
    title: "businessTerms.liability.title",
    body: ["businessTerms.liability.p1"],
  },
  {
    title: "businessTerms.indemnity.title",
    body: ["businessTerms.indemnity.p1"],
  },
  {
    title: "businessTerms.termination.title",
    body: ["businessTerms.termination.p1"],
  },
  {
    title: "businessTerms.changes.title",
    body: ["businessTerms.changes.p1"],
  },
  {
    title: "businessTerms.general.title",
    body: ["businessTerms.general.p1"],
  },
  {
    title: "businessTerms.governingLaw.title",
    body: ["businessTerms.governingLaw.p1"],
  },
  {
    title: "businessTerms.contact.title",
    body: ["businessTerms.contact.p1"],
  },
];

const BusinessTermsContent: React.FC = () => {
  const { t } = useTranslation();
  const { doc } = useLegalDocument("business_terms");

  if (doc) {
    return <LegalDocumentBody doc={doc} fallback={null} />;
  }

  return (
    <>
      <p className="leading-relaxed text-gray-600">{t("businessTerms.intro")}</p>
      <div className="mt-8 space-y-8">
        {SECTION_KEYS.map((section) => (
          <section key={section.title}>
            <h2 className="text-lg font-bold text-[#333]">{t(section.title)}</h2>
            <div className="mt-2 space-y-3 leading-relaxed text-gray-600">
              {section.body.map((key) => (
                <p key={key}>{t(key)}</p>
              ))}
            </div>
          </section>
        ))}
      </div>
    </>
  );
};

export default BusinessTermsContent;
